import request from '../../../../../services/axios';

interface IBankAccountInfoResponse {
  bank_info: IBankAccountInfo;
}
export interface IBankAccountInfo {
  bank_account_number: string;
  bank_title: string;
  guid: string;
  iban_number: string;
}

export const getBankAccountInfo = async () => {
  const {data}: {data: IBankAccountInfoResponse} = await request.get(
    `/api/v2/payment/cashback/bank-info`,
  );

  return data.bank_info;
};
